var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-button',{attrs:{"size":"small","type":"primary","icon":"el-icon-folder-add","plain":""},on:{"click":_vm.openFolder}},[_vm._v("新建文件夹")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }